module.exports = __webpack_public_path__ + "media/img/Group 5810-fb679807.svg";